import { conversionRates } from "./Helper";
const currencyValue = localStorage.getItem('currency_value');
const currency = localStorage.getItem('currency_label') ?? "₹";

export function DateFormaterMonth(GettedDate) {
    if (!GettedDate) {
        return ``;
    }

    const date = new Date(GettedDate);
    if (isNaN(date.getTime())) {
        return ``;
    }

    // Get the day, month (zero-padded), and year
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
}

export const convertCurrency = (amount, fromCurrency, toCurrency, round = false) => {
    if (round) {
        let converted = !toCurrency ? "INR" : toCurrency;
        if (fromCurrency === converted) return amount;

        if (fromCurrency === "INR" && converted === "USD") {
            return parseFloat((amount / conversionRates)?.toFixed(2));
        }
        if (fromCurrency === "USD" && converted === "INR") {
            return Math.round(amount * conversionRates);
        }
        console.error(`No conversion logic available for ${fromCurrency} to ${converted}`);
        return amount;
    }
    if (!round) {
        let converted = !toCurrency ? "INR" : toCurrency;
        if (fromCurrency === converted) return amount;

        if (fromCurrency === "INR" && converted === "USD") {
            return parseFloat((amount / conversionRates).toFixed(2));
        }
        if (fromCurrency === "USD" && converted === "INR") {
            return parseFloat((amount * conversionRates).toFixed(2));
        }
        console.error(`No conversion logic available for ${fromCurrency} to ${converted}`);
        return amount;
    }
};


export const formatPrice = (price, originalCurrency) => {
    const convertedPrice = convertCurrency(price, originalCurrency, currencyValue);
    return currencyValue === "INR" ? `${currency} ${convertedPrice?.toFixed(0)}` : `${currency} ${convertedPrice?.toFixed(2)}`;
};